import { ColumnDef } from '@tanstack/react-table'
import type { UserRow } from 'store/users/usersSlice'
import {
  ClientSummary,
  FitPlayerSummary,
  PremiumControls,
  SignupSummary,
  UserIdentity,
  UserRowActions,
  type UserRowHandlers,
} from 'ui/components/users/UserCells'

/**
 * Columns of the users table (desktop). On phones the page shows the same
 * pieces as one card per user (`UserMobileCard`).
 */
export const usersColumns = (
  handlers: UserRowHandlers
): ColumnDef<UserRow>[] => [
  {
    id: 'user',
    header: 'Utente',
    cell: ({ row }) => (
      <div className='max-w-80 min-w-56'>
        <UserIdentity user={row.original} onOpen={handlers.onOpen} />
        {row.original.is_banned && row.original.ban_notes && (
          <p className='mt-1 text-xs whitespace-normal text-red-700 dark:text-red-300'>
            Ban: {row.original.ban_notes}
          </p>
        )}
      </div>
    ),
  },
  {
    id: 'fit_player',
    header: 'Giocatore FIT',
    cell: ({ row }) => (
      <div className='max-w-64 min-w-40'>
        <FitPlayerSummary user={row.original} />
      </div>
    ),
  },
  {
    id: 'client',
    header: 'App / Web',
    cell: ({ row }) => <ClientSummary user={row.original} />,
  },
  {
    id: 'created_at',
    header: 'Iscrizione',
    cell: ({ row }) => <SignupSummary user={row.original} />,
  },
  {
    id: 'premium',
    header: 'Premium',
    cell: ({ row }) => (
      <PremiumControls user={row.original} handlers={handlers} />
    ),
  },
  {
    id: 'actions',
    header: '',
    cell: ({ row }) => (
      <UserRowActions user={row.original} handlers={handlers} />
    ),
  },
]
